module.exports = __webpack_public_path__ + "static/media/telegram.4c49693b.svg";